/** Parsed `ingestion_field_definition.field_config` for OBJECT_OCCURRENCE fields. */
export interface ObjectOccurrenceFieldConfig {
    showLocations: boolean;
    showResources: boolean;
}

const DEFAULT_CONFIG: ObjectOccurrenceFieldConfig = {
    showLocations: true,
    showResources: true,
};

/**
 * Parses JSON from `fieldDef.fieldConfig`. Invalid or missing values default both flags to true.
 */
export function parseObjectOccurrenceFieldConfig(fieldConfig: string | null | undefined): ObjectOccurrenceFieldConfig {
    if (fieldConfig == null || String(fieldConfig).trim() === "") {
        return { ...DEFAULT_CONFIG };
    }
    try {
        const raw = JSON.parse(fieldConfig) as Record<string, unknown>;
        return {
            showLocations: raw.showLocations !== false,
            showResources: raw.showResources !== false,
        };
    } catch {
        return { ...DEFAULT_CONFIG };
    }
}
